import * as Yup from "yup";
import { COMPANY_BASE_PROPERTIES } from "../../../../api/constants";
import { campaignDateValidation } from "./sharedValidationConfig"

export const mntnConfig = {
  ...COMPANY_BASE_PROPERTIES,
  /**
   * User Readable name of company the user is onBoarding with
   */
  companyText: "Onboarding With MNTN!",

  /**
   * lowercase no spaces or underscores name of company
   * This will be passed to the activate model and
   * used when saving to create the correct submission url
   */
  company: "mntn",

  /**
   * HTML that explains how to use the form
   */
  instructions:
    "Please provide the Start/End dates.<br><br>" +
    "<strong>Platform & Billing Notice</strong><br>"+
    "You have selected a platform that automatically reports audience usage for targeting.<br><br>" +
    "<ul><li> If this segment is used for <strong>targeting</strong>, you will be billed by the platform based on usage.</li>" +
    "<li>If this segment is used for <strong>suppression</strong>, billing will occur directly through Semcasting using the discounted deployed record rate.</li></ul>",

  /**
   * data used to create a company activation block
   */
  companyBlockOptions: {
    val: "mntn",
    text: "MNTN!",
    img: "mntn-logo.svg",
  },

  /**
   * anchor tag used to login to a specific platform
   */
  loginLink: "",

  layout: [
    {
      fieldType: "checkboxGroup",
      labelText: "IP Addresses",
      fieldName: "device_type",
      required: false,
      checkboxes: [
        {
          labelText: "Web Network / WiFi",
          fieldName: "web_network_wifi",
          value: "web_network_wifi",
          checked: true,
          disabled: false,
        },
      ],
    },
    {
      fieldType: "checkboxGroup",
      labelText: "Emails to Activate",
      fieldName: "device_type",
      required: true,
      checkboxes: [
        {
          labelText: "Hashed Emails",
          fieldName: "hashed_emails",
          value: "hashed_emails_sha256",
          checked: true,
          disabled: true,
        },
      ],
    },
    // {
    //   fieldType: "radioGroup",
    //   labelText: "Mobile Devices",
    //   fieldName: "mobile_devices",
    //   required: true,
    //   radioButtons: [
    //     {
    //       labelText: "Top Devices",
    //       fieldName: "top_devices",
    //       value: "top_ios_android",
    //       checked: true,
    //     },
    //     {
    //       labelText: "All Devices",
    //       fieldName: "all_devices",
    //       value: "ios_android",
    //       checked: false,
    //     },
    //   ],
    // },
    {
      fieldType: "dateRange",
      fieldName: "campaign_range",
      labelText: "Campaign Date Range",
      required: "dateRangeRequired",
    },
    {
      fieldType: 'savableFieldsWrapper',
      layout: [
        {
          fieldType: 'searchSelect',
          fieldName: 'seat_id',
          labelText: 'Mountain Account ID',
          url: '/v2/secure/attributor/activate-credentials/mntn/seat_id',
          placeholder: 'Select a Mountain Account ID or add a new one',
          namePropName: 'value',
          textPropName: 'value',
          valuePropName: 'id',
          required: true,
          validation: [{
            required: function (value, attr, computed) {
              if (!value) {
                return 'Mountain Account ID is required'
              }
            }
          }]
        }, {
          fieldType: 'checkbox',
          fieldName: 'save_credentials',
          labelText: 'Save Mountain Account ID</span> for future use',
          checked: false,
        }
      ]
    },
    {
      fieldType: "pricing",
    },
    {
      fieldType: "radioGroup",
      labelText: "Planned Usage of this Segment:",
      fieldName: "audience_usage",
      required: true,
      radioButtons: [
        {
          labelText: "Targeting",
          fieldName: "use_type_inclusion",
          value: "I",
          checked: false,
        },
        {
          labelText: "Suppression",
          fieldName: "use_type_exclusion",
          value: "X",
          checked: false,
        },
      ],
    },
    {
      fieldType: "selectPickerTag",
      fieldName: "creativeTagIdDropDown",
      labelText: "Creative Tag ID",
      url: "/v2/secure/attributor/creative-tags",
      placeholder: "Select a New or existing Tag for your creative",
      namePropName: "creativeTagId",
      textPropName: "creativeTagId",
      valuePropName: "creativeTagId",
      required: true,
    },
    {
      fieldType: "creativeTagId",
      fieldName: "creativeTagId",
      labelText: "Creative Tag ID",
      required: true,
    },
    {
      fieldType: "creativeTag",
      fieldName: "creativeTag",
      labelText: "Creative Tag",
      required: true,
    }
  ],

  /**
   * an array of property names that can be saved and repeatedly used to "Activate/OnBoard" with a specific company
   */
  savableDataNames: ["seat_id"],

  formik: {
    initialValues: {
      mobile_devices: "",
      campaign_range_start: "",
      campaign_range_end: "",
      device_type: ["hashed_emails_sha256","web_network_wifi"],
      audience_usage:"",
      creativeTagIdDropDown:"",
      creativeTagId:"",
    },
    // We used Yup here for input format validation.
    validationSchema: Yup.object().shape({
      ...campaignDateValidation,
      audience_usage: Yup.string().required("Planned Usage is required"),
      seat_id: Yup.string().required("Please enter Mountain account ID"),
      creativeTagIdDropDown:Yup.string().required("Creative Tag ID is required"),
      creativeTagId: Yup.string().required("Creative Tag ID is required"),
    }),
    onSubmit: (values) => {},
  },
};
